import { render, staticRenderFns } from "./Wizard-Profile.vue?vue&type=template&id=597fa790&scoped=true"
import script from "./Wizard-Profile.vue?vue&type=script&lang=js"
export * from "./Wizard-Profile.vue?vue&type=script&lang=js"
import style0 from "./Wizard-Profile.vue?vue&type=style&index=0&id=597fa790&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597fa790",
  null
  
)

export default component.exports